import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';
import React from 'react';
import colors from '../../theme/colors';
import { HazardSurveyStatus } from '@/services/hazardSurvey';

const surveyStatusOptions = [
  {
    value: 'NEW' as HazardSurveyStatus,
    label: 'New',
    color: colors.statusDefault,
  },
  {
    value: 'IN_PROGRESS' as HazardSurveyStatus,
    label: 'In Progress',
    color: colors.statusPrimary,
  },
  {
    value: 'IN_REVIEW' as HazardSurveyStatus,
    label: 'In Review',
    color: colors.statusWarning,
  },
  {
    value: 'ACCEPTED' as HazardSurveyStatus,
    label: 'Accepted',
    color: colors.statusSuccess,
  },
  {
    value: 'CANCELLED' as HazardSurveyStatus,
    label: 'Cancelled',
    color: colors.statusError,
  },
] as const;

type MultiProps = {
  value?: HazardSurveyStatus[];
  onChange: (value?: HazardSurveyStatus[]) => void;
  isMulti?: true;
  placeholder?: string;
};

type SingleProps = {
  value?: HazardSurveyStatus | null;
  onChange: (value?: HazardSurveyStatus | null) => void;
  isMulti: false;
  placeholder?: string;
};

export const HazardSurveyStatusPicker = (props: MultiProps | SingleProps) => {
  if (props.isMulti === false) {
    const selectedValue = props.value
      ? (surveyStatusOptions.find((o) => o.value === props.value) ?? null)
      : null;
    return (
      <ReactSelect
        placeholder={props.placeholder ?? 'Status'}
        isClearable
        value={selectedValue}
        styles={{
          menu: (base) => ({ ...base, minWidth: '160px' }),
          singleValue: formatDotStyles,
        }}
        formatOptionLabel={formatDotLabel}
        onChange={(v: any) =>
          props.onChange(v ? (v.value as HazardSurveyStatus) : null)
        }
        options={surveyStatusOptions}
      />
    );
  }

  const selectedValues = surveyStatusOptions.filter((option) =>
    props.value?.includes(option.value)
  );

  return (
    <ReactSelect
      placeholder={props.placeholder ?? 'status'}
      isMulti
      isClearable={false}
      value={selectedValues}
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '160px',
        }),
        multiValue: formatDotStyles,
      }}
      formatOptionLabel={formatDotLabel}
      onChange={(values) => {
        if (Array.isArray(values)) {
          props.onChange(
            values.length > 0
              ? values.map((v) => v.value as HazardSurveyStatus)
              : undefined
          );
        } else {
          props.onChange(undefined);
        }
      }}
      options={surveyStatusOptions}
    />
  );
};
